module.exports = __webpack_public_path__ + "img/cornell-logo.8ae18ff9.png";